import styled, { css } from 'styled-components';

export const ContainerPopup = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 280px;
    height: 132px;
    background-color: ${theme.color.background.neutral.default};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: ${theme.border.radius.default};
    padding: ${theme.padding.km4};

    .icon-alert {
      color: ${theme.color.support.orange.strong};
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid ${theme.color.background.neutral.default};
    }
  `}
`;

export const PopupContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    gap: ${theme.spacing.km2};
  `}
`;

export const HeaderContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.km2};
  `}
`;

export const PopupDescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.font.size.m2};
    font-weight: ${theme.font.weight.medium};
    color: ${theme.color.text.neutral.default};
    margin-bottom: ${theme.spacing.km2};
  `}
`;

export const ToolTipDescription = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.font.size.m2};
    font-weight: ${theme.font.weight.medium};
    color: ${theme.color.text.neutral.inverted};
    border-radius: ${theme.border.radius.medium};
  `}
`;

export const ToolTipContainer = styled.div`
  ${({ theme }) => css`
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -22px;
      left: 1px;
      transform: translateX(0);
      width: 0;
      height: 0;
      border-left: 10px ${theme.border.style.solid} transparent;
      border-right: 10px ${theme.border.style.solid} transparent;
      border-top: 10px ${theme.border.style.solid}
        ${theme.color.border.neutral.strong};
    }
  `}
`;

export const CustomCloseButton = styled.button`
  ${({ theme }) => css`
    background: transparent;
    position: absolute;
    cursor: pointer;
    border: ${theme.border.width.none};
    top: 2px;
    right: ${theme.spacing.km6};
    font-size: ${theme.font.size.m8};
    color: ${theme.color.text.neutral.strong};
  `}
`;
